module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/@babel/runtime/core-js/object/assign.js
// module id = 383
// module chunks = 35783957827783 114276838955818